import styled from 'styled-components'

export const CardWrapper = styled.div`
  border: ${({ $noBorder }) => ($noBorder ? 'none' : '1px solid #e5e7eb')};
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: ${({ $legendPosition }) => ($legendPosition === 'right' || $legendPosition === 'left' ? 'row' : 'column')};
  align-items: ${({ $legendPosition }) => ($legendPosition === 'right' || $legendPosition === 'left' ? 'center' : 'stretch')};
  justify-content: flex-start;
  gap: ${({ $legendPosition }) => ($legendPosition === 'right' || $legendPosition === 'left' ? '24px' : '0')};
`

export const CardBody = styled.div`
  flex: 1;
  min-width: 0;
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #111827;
`

export const ChartWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const CenterLabel = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  pointer-events: none;
  z-index: 1000;
`

export const LegendWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: ${({ $legendPosition }) => ($legendPosition === 'right' || $legendPosition === 'left' ? '0' : '32px')};
  flex-shrink: 0;
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 14px;
  color: #111827;
  white-space: nowrap;
`

export const LegendDot = styled.span`
  width: 16px;
  height: 16px;
  background: ${({ color }) => color};
  flex-shrink: 0;
`

// Anchored to a fixed corner of the chart — never positioned from cursor
// coordinates, so it can't drift over the donut or lag behind the mouse.
export const FixedTooltip = styled.div`
  position: absolute;
  top: 8px;
  left: min(calc(50% + ${({ $chartHeight }) => ($chartHeight ? $chartHeight * 0.25 : 60)}px), calc(100% - 150px));
  min-width: 140px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  pointer-events: none;
  z-index: 1000;
`

export const FixedTooltipHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  font-size: 13px;
  color: #111827;
`

export const FixedTooltipDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex-shrink: 0;
`

export const FixedTooltipValue = styled.div`
  font-size: 13px;
  color: #374151;
`